export type ModuleAccessLevel = 'none' | 'read' | 'write';

export const MODULE_ACCESS_LEVELS: Array<{
  value: ModuleAccessLevel;
  label: string;
  shortLabel: string;
  description: string;
}> = [
  {
    value: 'none',
    label: 'Hidden',
    shortLabel: 'Hidden',
    description: 'Menu item is not shown and the person cannot open this area.',
  },
  {
    value: 'read',
    label: 'View only',
    shortLabel: 'View',
    description: 'Can open and read information, but cannot add or change records.',
  },
  {
    value: 'write',
    label: 'View & edit',
    shortLabel: 'Edit',
    description: 'Can open the area and create or update records (full use).',
  },
];

export function moduleAccessLevelLabel(level: ModuleAccessLevel): string {
  return MODULE_ACCESS_LEVELS.find((entry) => entry.value === level)?.label ?? level;
}

export function moduleAccessLevelShortLabel(level: ModuleAccessLevel): string {
  return MODULE_ACCESS_LEVELS.find((entry) => entry.value === level)?.shortLabel ?? level;
}

export function moduleAccessLevelDescription(level: ModuleAccessLevel): string {
  return MODULE_ACCESS_LEVELS.find((entry) => entry.value === level)?.description ?? '';
}
